<!-- 4-up window, center two cards enlarged; auto-advances 1 card / 7s (350ms ease-out);
     pauses on hover. Horizontal clip only — vertical padding keeps card shadows. -->
<div class="fp-carousel" *ngIf="items?.length">
  <div class="fp-viewport" (mouseenter)="stopAuto()" (mouseleave)="startAuto()">
    <ul class="fp-track" #fpTrack [class.fp-track--anim]="fpAnim"
      [style.transform]="'translateX(-' + (fpPos * fpStride) + 'px)'"
      (transitionend)="onFpTransitionEnd($event)">
      @for (item of fpItems; track $index) {
      <li class="fp-slot">
        <app-featured-product-card [item]="item" [signedIn]="signedIn"></app-featured-product-card>
      </li>
      }
    </ul>
  </div>
  <div class="fp-dots" *ngIf="showDots && fpN > 1">
    @for (p of items; track $index; let i = $index) {
    <button type="button" class="fp-dot" [class.active]="i === (fpPos % fpN)"
      (click)="goFp(i)" [attr.aria-label]="'Go to item ' + (i + 1)"></button>
    }
  </div>
</div>
